export default __webpack_public_path__ + "static/media/resultrest.323a6745.jpg";